// extracted by css-extract-rspack-plugin
export default {"text":"qzhNgeVQmcsd5YXq"};